import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChiefEditorAuthGuard } from '../guards/chief-editor-auth.guard';
import { PageUrls, PageUrlsParts } from '../helpers/page-urls';
import { ChiefEditorComponent } from './chief-editor.component';
import { AddEventComponent } from './components/add-event/add-event.component';
import { RawImageManageComponent, RawImagePendingGroupedComponent } from './components/raw-image';

const routes: Routes = [
    {
        path: PageUrlsParts.ChiefEditor.Self,
        component: ChiefEditorComponent,
        canActivate: [ChiefEditorAuthGuard],
        children: [
            { path: '', redirectTo: PageUrls.ChiefEditor.Dashboard, pathMatch: 'full' },
            { path: PageUrlsParts.ChiefEditor.PendingGrouped, component: RawImagePendingGroupedComponent },
            { path: PageUrlsParts.ChiefEditor.AddEvent, component: AddEventComponent },
            { path: PageUrlsParts.Editor.RawImageManage, component: RawImageManageComponent },
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChiefEditorRoutingModule { }
